// @flow @format
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'lib/classnames';
import './FileListHeader.css';

import type {Node} from 'react';

type Props = {
	children?: Node,
	className?: string,
	style?: Object,
};

export const FileListHeader = ({children, className = '', style = {}}: Props) =>
	<div style={style} className={classNames('FileList__Header', className)}>
		{children}
	</div>;

FileListHeader.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]),
	style: PropTypes.object,
	className: PropTypes.string,
};

export const FileListHeaderRow = ({
	children,
	className = '',
	style = {},
}: Props) =>
	<div
		style={style}
		className={classNames('FileList__Header__Row', className)}
	>
		{children}
	</div>;

FileListHeaderRow.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]),
	style: PropTypes.object,
	className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/FileList/FileListHeader.js